import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProperties } from "../../../Theme/ThemeProperties";
import { SecondaryTab, StyledTabContainer } from "../../../Components/CustomTab";

/**
 * Custom platform tab bar — identical to DigitalTwinTabs but without the
 * Advanced Analytics shortcut button.
 */
export default function CustomDigitalTwinTabs({
    tabs = [],
    selectedTab,
    changeTheTab = () => {},
}) {
    const [currentTab, setCurrentTab] = React.useState(selectedTab);

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        changeTheTab(newValue);
    };

    React.useEffect(() => {
        setCurrentTab(selectedTab);
    }, [selectedTab]);

    return (
        <Box
            sx={{
                borderBottom: "1px solid #E6E6E6",
                display: "flex",
                alignItems: "center",
            }}
        >
            <StyledTabContainer
                value={currentTab}
                onChange={handleChange}
                aria-label="secondary tabs"
                elevation={1}
                myColor={ThemeProperties.purple}
            >
                {tabs.map((item) => (
                    <SecondaryTab value={item.slug} key={item.id} label={item.name} />
                ))}
            </StyledTabContainer>
        </Box>
    );
}
